// extracted by mini-css-extract-plugin
export default {"title":"page-title_title__eCSwu","link":"page-title_link__19+oP","linkArrow":"page-title_linkArrow__NRl7k"};